import { type ProcessingTimeTrendMonthlySeriesItem } from '../processing-time-trend-dialog/types'

export const mockMonthlySeriesProcessingTime: ProcessingTimeTrendMonthlySeriesItem[] = [
  { date: '2024-08-01', estimatedTime: 6.5, caseInquiryDate: null, caseInquiryDateDecimalYear: null },
  { date: '2024-09-01', estimatedTime: 6.8, caseInquiryDate: null, caseInquiryDateDecimalYear: null },
  { date: '2024-10-01', estimatedTime: 7.1, caseInquiryDate: null, caseInquiryDateDecimalYear: null },
  { date: '2024-11-01', estimatedTime: 7.4, caseInquiryDate: null, caseInquiryDateDecimalYear: null },
  { date: '2024-12-01', estimatedTime: 7.6, caseInquiryDate: null, caseInquiryDateDecimalYear: null },
  { date: '2025-01-01', estimatedTime: 7.7, caseInquiryDate: null, caseInquiryDateDecimalYear: null },
  { date: '2025-02-01', estimatedTime: 7.5, caseInquiryDate: null, caseInquiryDateDecimalYear: null },
  { date: '2025-03-01', estimatedTime: 7.2, caseInquiryDate: null, caseInquiryDateDecimalYear: null },
  { date: '2025-04-01', estimatedTime: 6.9, caseInquiryDate: null, caseInquiryDateDecimalYear: null },
  { date: '2025-05-01', estimatedTime: 6.8, caseInquiryDate: null, caseInquiryDateDecimalYear: null },
  { date: '2025-06-01', estimatedTime: 6.9, caseInquiryDate: null, caseInquiryDateDecimalYear: null },
  { date: '2025-07-01', estimatedTime: 7.0, caseInquiryDate: null, caseInquiryDateDecimalYear: null },
]

export const mockMonthlySeriesInquiryDate: ProcessingTimeTrendMonthlySeriesItem[] = [
  {
    date: '2024-08-01',
    estimatedTime: null,
    caseInquiryDate: '2023-08-05',
    caseInquiryDateDecimalYear: 2023.5941780822,
  },
  {
    date: '2024-09-01',
    estimatedTime: null,
    caseInquiryDate: '2023-08-10',
    caseInquiryDateDecimalYear: 2023.6063301901,
  },
  {
    date: '2024-10-01',
    estimatedTime: null,
    caseInquiryDate: '2023-08-23',
    caseInquiryDateDecimalYear: 2023.6418020223,
  },
  {
    date: '2024-11-01',
    estimatedTime: null,
    caseInquiryDate: '2023-09-12',
    caseInquiryDateDecimalYear: 2023.697719862,
  },
  {
    date: '2024-12-01',
    estimatedTime: null,
    caseInquiryDate: '2023-10-08',
    caseInquiryDateDecimalYear: 2023.7695535783,
  },
  {
    date: '2025-01-01',
    estimatedTime: null,
    caseInquiryDate: '2023-11-07',
    caseInquiryDateDecimalYear: 2023.8514836307,
  },
  {
    date: '2025-02-01',
    estimatedTime: null,
    caseInquiryDate: '2023-12-08',
    caseInquiryDateDecimalYear: 2023.9368725337,
  },
  {
    date: '2025-03-01',
    estimatedTime: null,
    caseInquiryDate: '2024-01-07',
    caseInquiryDateDecimalYear: 2024.0188025861,
  },
  {
    date: '2025-04-01',
    estimatedTime: null,
    caseInquiryDate: '2024-02-03',
    caseInquiryDateDecimalYear: 2024.0906363024,
  },
  {
    date: '2025-05-01',
    estimatedTime: null,
    caseInquiryDate: '2024-02-23',
    caseInquiryDateDecimalYear: 2024.146554142,
  },
  {
    date: '2025-06-01',
    estimatedTime: null,
    caseInquiryDate: '2024-03-07',
    caseInquiryDateDecimalYear: 2024.1820259743,
  },
  {
    date: '2025-07-01',
    estimatedTime: null,
    caseInquiryDate: '2024-03-12',
    caseInquiryDateDecimalYear: 2024.1941780822,
  },
]
